import { Component, OnInit } from '@angular/core';
@Component({
  selector: 'app-icd10v3',
  templateUrl: './icd10v3.component.html',
  styleUrls: ['./icd10v3.component.scss']
})
export class Icd10v3Component implements OnInit {
  searchKeyword: string = '';
  selectedAction: string = '';
  selectedCount: number = 0;
  totalCount: number = 0;
  selectAll: boolean = false;
  actionMessage: string = '';
  rows: { id: number; name: string; details: string; selected: boolean }[] = [];
  filteredRows: { id: number; name: string; details: string; selected: boolean }[] = [];
  displayedRows: { id: number; name: string; details: string; selected: boolean }[] = [];
  newName: string = '';
  newDetails: string = '';
  editingRow: { id: number; name: string; details: string } | null = null;
  currentPage: number = 1;
  rowsPerPage: number = 10;
  totalPages: number = 0;

  ngOnInit(): void {
    this.rows = [
      { id: 1, name: 'Bệnh lý 1', details: 'Chi tiết bệnh lý 1', selected: false },
      { id: 2, name: 'Bệnh lý 2', details: 'Chi tiết bệnh lý 2', selected: false },
      { id: 3, name: 'Bệnh lý 3', details: 'Chi tiết bệnh lý 3', selected: false },
      { id: 4, name: 'Bệnh lý 4', details: 'Chi tiết bệnh lý 4', selected: false },
      { id: 5, name: 'Bệnh lý 5', details: 'Chi tiết bệnh lý 5', selected: false },
      { id: 6, name: 'Bệnh lý 6', details: 'Chi tiết bệnh lý 6', selected: false },
      { id: 7, name: 'Bệnh lý 7', details: 'Chi tiết bệnh lý 7', selected: false },
      { id: 8, name: 'Bệnh lý 8', details: 'Chi tiết bệnh lý 8', selected: false },
      { id: 9, name: 'Bệnh lý 9', details: 'Chi tiết bệnh lý 9', selected: false },
      { id: 10, name: 'Bệnh lý 10', details: 'Chi tiết bệnh lý 10', selected: false },
      { id: 11, name: 'Bệnh lý 11', details: 'Chi tiết bệnh lý 11', selected: false },
      { id: 12, name: 'Bệnh lý 12', details: 'Chi tiết bệnh lý 12', selected: false },
      { id: 13, name: 'Bệnh lý 13', details: 'Chi tiết bệnh lý 13', selected: false },
      { id: 14, name: 'Bệnh lý 14', details: 'Chi tiết bệnh lý 14', selected: false },
      { id: 15, name: 'Bệnh lý 15', details: 'Chi tiết bệnh lý 15', selected: false },
      { id: 16, name: 'Bệnh lý 16', details: 'Chi tiết bệnh lý 16', selected: false },
      { id: 17, name: 'Bệnh lý 17', details: 'Chi tiết bệnh lý 17', selected: false },
      { id: 18, name: 'Bệnh lý 18', details: 'Chi tiết bệnh lý 18', selected: false },
      { id: 19, name: 'Bệnh lý 19', details: 'Chi tiết bệnh lý 19', selected: false },
      { id: 20, name: 'Bệnh lý 20', details: 'Chi tiết bệnh lý 20', selected: false },
    ];
    this.filteredRows = [...this.rows];
    this.totalCount = this.filteredRows.length;
    this.totalPages = Math.ceil(this.totalCount / this.rowsPerPage);
    this.updateDisplayedRows();
  }

  exportFile(): void {
    const selectedRows = this.filteredRows.filter(row => row.selected);
    if (selectedRows.length === 0) {
      this.actionMessage = 'Vui lòng chọn ít nhất một bệnh lý để xuất!';
      return;
    }
    const csvData = this.convertToCSV(selectedRows);
    const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = 'selected_rows.csv';
    link.click();
    this.actionMessage = 'Xuất file thành công!';
  }

  convertToCSV(rows: { id: number; name: string; details: string; selected: boolean }[]): string {
    if (!rows || rows.length === 0) {
      console.error('No rows to convert to CSV');
      return '';
    }
    const header = 'ID,Name,Details\n';
    const rowsData = rows.map(row => `${row.id},${row.name},${row.details}`).join('\n');
    return header + rowsData;
  }

  onSearch(): void {
    if (this.searchKeyword.trim()) {
      this.filteredRows = this.rows.filter(
        row =>
          row.name.toLowerCase().includes(this.searchKeyword.toLowerCase()) ||
          row.details.toLowerCase().includes(this.searchKeyword.toLowerCase())
      );
    } else {
      this.filteredRows = [...this.rows];
    }
    this.totalCount = this.filteredRows.length;
    this.totalPages = Math.ceil(this.totalCount / this.rowsPerPage);
    this.currentPage = 1;
    this.updateDisplayedRows();
  }

  performAction(): void {
    switch (this.selectedAction) {
      case 'add':
        this.addRow();
        break;
      case 'edit':
        this.editRow();
        break;
      case 'delete':
        this.deleteRows();
        break;
      case 'export':
        this.exportFile();
        break;
      default:
        this.actionMessage = 'Chọn hành động hợp lệ';
        break;
    }
  }

  addRow(): void {
    if (this.newName && this.newDetails) {
      const newRow = { 
        id: this.rows.length + 1, 
        name: this.newName, 
        details: this.newDetails, 
        selected: false 
      };
      this.rows.push(newRow);
      this.filteredRows = [...this.rows];
      this.totalCount = this.rows.length;
      this.totalPages = Math.ceil(this.totalCount / this.rowsPerPage);
      this.updateDisplayedRows();
      this.actionMessage = 'Thêm bệnh lý thành công!';
      this.resetForm();
    } else {
      this.actionMessage = 'Vui lòng nhập tên và chi tiết bệnh lý!';
    }
  }

  editRow(): void {
    const selectedRows = this.filteredRows.filter(row => row.selected);
    if (selectedRows.length === 1) {
      const row = selectedRows[0];
      if (this.newName && this.newDetails) {
        row.name = this.newName;
        row.details = this.newDetails;
        this.actionMessage = 'Chỉnh sửa bệnh lý thành công!';
        this.resetForm();
      } else {
        this.actionMessage = 'Vui lòng nhập tên và chi tiết bệnh lý!';
      }
    } else {
      this.actionMessage = 'Vui lòng chọn một bệnh lý để chỉnh sửa.';
    }
  }

  deleteRows(): void {
    const selectedRows = this.filteredRows.filter(row => row.selected);
    if (selectedRows.length > 0) {
      this.rows = this.rows.filter(row => !row.selected);
      this.filteredRows = this.filteredRows.filter(row => !row.selected);
      this.totalCount = this.rows.length;
      this.totalPages = Math.ceil(this.totalCount / this.rowsPerPage);
      this.updateDisplayedRows();
      this.actionMessage = 'Xóa bệnh lý thành công!';
    } else {
      this.actionMessage = 'Vui lòng chọn ít nhất một bệnh lý để xóa.';
    }
  }

  updateSelectedCount(): void {
    this.selectedCount = this.filteredRows.filter((row) => row.selected).length;
  }

  toggleSelectAll(): void {
    this.filteredRows.forEach((row) => (row.selected = this.selectAll));
    this.updateSelectedCount();
  }

  resetForm(): void {
    this.newName = '';
    this.newDetails = '';
    this.editingRow = null;
  }

  startEditing(row: { id: number; name: string; details: string }): void {
    this.newName = row.name;
    this.newDetails = row.details;
    this.editingRow = row;
  }

  updateDisplayedRows(): void {
    const start = (this.currentPage - 1) * this.rowsPerPage;
    const end = start + this.rowsPerPage;
    this.displayedRows = this.filteredRows.slice(start, end);
  }

  goToPage(page: number): void {
    if (page > 0 && page <= this.totalPages) {
      this.currentPage = page;
      this.updateDisplayedRows();
    }
  }

  nextPage(): void {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      this.updateDisplayedRows();
    }
  }

  prevPage(): void {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.updateDisplayedRows();
    }
  }


  userFeedback: string = '';
feedbackMessage: string = '';

submitFeedback() {
    if (this.userFeedback.trim()) {
        
        this.feedbackMessage = 'Cảm ơn bạn đã gửi góp ý!';
        this.userFeedback = ''; 
    } else {
        this.feedbackMessage = 'Vui lòng nhập nội dung góp ý.';
    }

    
    setTimeout(() => {
        this.feedbackMessage = '';
    }, 3000);
}

}
